import { render, staticRenderFns } from "./EnableTwoFactorAuthentication.vue?vue&type=template&id=271d0092&scoped=true&"
import script from "./EnableTwoFactorAuthentication.vue?vue&type=script&lang=js&"
export * from "./EnableTwoFactorAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d0092",
  null
  
)

export default component.exports